import { Injectable, NgZone } from '@angular/core';
import { PixiConfiguration } from '../js-libs/pixie/config';
import { Subject } from 'rxjs/Subject';
import { IImageFile } from '../interfaces/files.interface';
import { Observable } from 'rxjs';
import { Logger } from '../monitoring/logger/logger';
import { SpinnerService } from '../components/spinner/spinner.service';

declare var Pixie: any; // Pixie load from 3rd part code from javascript file, not type safety

@Injectable()
export class ImageEditorService {

  pixieEditor: any;
  config: any;

  constructor(private spinnerService: SpinnerService, private zone: NgZone, private logger: Logger) {
    const pixiConfiguration = new PixiConfiguration();
    this.config = pixiConfiguration.pixieConfig;
  }

  openImageEditor(publicImgSrc: string, currentUserLanguage: string): Observable<any> {

    const pixieSave: Subject<IImageFile> = new Subject<IImageFile>();

    try {

      if (!this.pixieEditor) {
        const pixieCustomConfig = JSON.parse(JSON.stringify(this.config));
        if (currentUserLanguage === '1036') {
          pixieCustomConfig.languages.active = 'french';
        }

        pixieCustomConfig.onSave = (data: any, name: any) => {
          this.zone.run(() => {
            this.spinnerService.show();
            this.pixieEditor.close();
            pixieSave.next(data);
          });
        };

        pixieCustomConfig.onClose = this.onPixieClose.bind(this);
        pixieCustomConfig.image = publicImgSrc;

        // run pixie outside the current application's-angular-zone since it has it's own zone to manage (it's an angular app by-itself)
        // I added this since there was an assertion on the console.
        this.zone.runOutsideAngular(() => {
          this.pixieEditor = new Pixie(pixieCustomConfig);
        });

      } else {
        this.pixieEditor.setConfig('onClose', this.onPixieClose.bind(this));
        this.pixieEditor.setConfig('onSave', (data: any, name: any) => {
          this.zone.run(() => {
            this.spinnerService.show();
            pixieSave.next(data);
            this.pixieEditor.close();
          });

        });
        this.pixieEditor.resetEditor();
        this.pixieEditor.resetAndOpenEditor('image', publicImgSrc);

      }

    } catch (err) {

      console.log(err.message);

    }

    return pixieSave.asObservable();
  }

  onPixieClose() {
    this.zone.run(() => {
      if (this.pixieEditor) {
        this.pixieEditor.resetEditor();
      }
    });
  }

}
